import React from 'react'

import styled from 'styled-components'
import { Icon } from 'components/styled/icon'
import { LabelStyle } from 'components/styled/typography/styles'
import { Button } from 'components/styled/button'
import { StyledButton } from 'components/styled/button/button'
import { Flex, FlexProps } from 'components/styled/containers/flex'
import { ConfirmDelete } from 'components/confirm-delete'

export interface TagProps extends FlexProps {
  icon?: string
  text: string | React.ReactNode
  onRemove?: () => void
  showConfirmation?: boolean
}

export const StyledTag = styled(Flex)`
  align-items: center;

  box-sizing: border-box;
  width: fit-content;

  background-color: ${({ theme }) => theme.color.grey07};
  border-radius: ${({ theme }) => theme.space.s4};
`

export const ContentWrapper = styled.div<{
  $isRemovable: boolean
  $hasIcon: boolean
}>`
  display: flex;
  align-items: center;

  padding: ${({ theme }) => theme.space.s4};
  padding-left: ${({ theme, $hasIcon }) =>
    $hasIcon ? theme.space.s8 : theme.space.s16};
  padding-right: ${({ theme, $isRemovable }) =>
    $isRemovable ? theme.space.s8 : theme.space.s16};
`

const Text = styled.div<{ $hasIcon: boolean }>`
  ${LabelStyle};
  color: ${({ theme }) => theme.color.grey90};
  padding-left: ${({ theme, $hasIcon }) => $hasIcon && theme.space.s8};
`
const RemoveButton = styled(Button).attrs({
  variant: 'secondary',
  size: 'small',
  icon: 'clear',
})`
  padding: 0;

  ${StyledButton} {
    border-radius: 0;
    border-top-right-radius: ${({ theme }) => theme.space.s4};
    border-bottom-right-radius: ${({ theme }) => theme.space.s4};
  }
`

export const Tag = ({
  icon,
  text,
  onRemove,
  showConfirmation,
  ...props
}: TagProps) => {
  return (
    <StyledTag {...props}>
      <ContentWrapper $isRemovable={!!onRemove} $hasIcon={!!icon}>
        {icon && <Icon size="s16" color="grey60" type={icon} />}
        <Text $hasIcon={!!icon}>{text}</Text>
      </ContentWrapper>
      {onRemove && !showConfirmation && <RemoveButton onClick={onRemove} />}
      {showConfirmation && onRemove && (
        <Flex pl="s8">
          <ConfirmDelete
            item={text}
            size="small"
            onConfirm={() => onRemove()}
          />
        </Flex>
      )}
    </StyledTag>
  )
}
